import {useState} from 'react';
import PropTypes from 'prop-types';

export default function NewChecklistModal({onConfirm, onCancel}) {
    const [title, setTitle] = useState('');

    function submit() {
        const t = title.trim();
        if (!t) return;
        onConfirm(t);
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') submit();
        if (e.key === 'Escape') onCancel();
    }

    return (
        <div
            className="modal-backdrop"
            onClick={onCancel}
            onKeyDown={e => e.key === 'Escape' && onCancel()}
            role="presentation"
        >
            <div
                className="modal"
                onClick={e => e.stopPropagation()}
                onKeyDown={e => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <h3 className="modal-title">New List</h3>
                <input
                    className="modal-input"
                    type="text"
                    placeholder="List title"
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoFocus
                />
                <div className="modal-actions">
                    <button className="modal-cancel" onClick={onCancel}>Cancel</button>
                    <button className="modal-confirm" onClick={submit} disabled={!title.trim()}>Create</button>
                </div>
            </div>
        </div>
    );
}

NewChecklistModal.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
